export const BASE_URL = 'https://patelhospital.com/admin-portal/api';